import { CalendarPlanShowcaseConfigGivenOutStatus as LessonGiveOutStatus } from '@yandex-int/k-common';
import b from 'b_';
import cx from 'classnames';
import React from 'react';

import { MarkdownExtXContent as Markdown } from '../markdown/markdown';
import Text from '../text/text';

import { LessonPreview } from './__lesson-preview/showcase-card__lesson-preview';

import './showcase-card.scss';

export interface ShowcaseLesson {
    id: number; // id для кнопки
    name: string; // имя занятия
    enabled: boolean; // доступно для взаимодействия и отображается состояние выдачи
    status: LessonGiveOutStatus; // статус выдачи
    canBeGiven: boolean; // можно ли выдать урок
    isLessonBeingGivenNow: boolean; // урок сейчас выдаётся
    image: string;
    backgroundColor?: string; // цвет фона карточки, заменяет собой цвет по-умолчанию
    content: {
        //  Record<string, string>
        skills: string; // навыки
        teacherMark: string; // оценка
        description?: string; // Любой другой маркдаун, отображается под блоком "О ЗАНЯТИИ"
        unavailableStatusMessage?: string;
    };
}

interface Props {
    className?: string;
    lesson: ShowcaseLesson;
    onPreviewClick?: () => void;
}

export const ShowcaseCard = ({ className, lesson, onPreviewClick }: Props) => {
    const { backgroundColor, content } = lesson;

    return (
        <div className={cx('showcase-card', className)} style={{ backgroundColor }}>
            <LessonPreview className={b('showcase-card', 'lesson-preview')} lesson={lesson} onClick={onPreviewClick} />
            <div className={b('showcase-card', 'content')}>
                <div className={b('showcase-card', 'skills')}>
                    <Text id={'showcaseCard.skills'} size={Text.SIZE.S} weight={Text.WEIGHT.M} />
                    <div className={b('showcase-card', 'skills-markdown')}>
                        <Markdown>{content.skills}</Markdown>
                    </div>
                </div>
                {content.description && (
                    <div className={b('showcase-card', 'composition')}>
                        <div className={b('showcase-card', 'composition-header')}>
                            <Text id={'showcaseCard.composition'} weight={Text.WEIGHT.M} />
                        </div>
                        <div className={b('showcase-card', 'composition-list')}>
                            <Markdown>{content.description}</Markdown>
                        </div>
                    </div>
                )}
                <div className="teacher-mark">
                    <div className={b('teacher-mark', 'mark')}>
                        <Text weight={Text.WEIGHT.M}>{content.teacherMark}</Text>
                    </div>
                    <div className={b('teacher-mark', 'description')}>
                        <Text id={'showcaseCard.teacherMark'} size={Text.SIZE.XL} />
                    </div>
                </div>
            </div>
        </div>
    );
};
